import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FncGroup } from '../../auth/FncGroup';
import { filter, map, takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { Injectable, OnDestroy } from '@angular/core';
import { UserLoginState } from '../../auth/CurrentLoginUser';

@Injectable({
  providedIn: 'root'
})
export abstract class AbstractFncGroupGuard  implements OnDestroy {
  readonly destroy$: Subject<boolean> = new Subject<boolean>();

  protected constructor(
    private fncGroups: FncGroup[],
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private router: Router,
  ) {
    if (!fncGroups || fncGroups.length === 0) {
      console.error('FNC GROUP GUARD WITH INVALID FNC GROUP DECLARATION: ', fncGroups);
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authService
      .observeLoginState()
      .pipe(
        takeUntil(this.destroy$),
        filter(loginState => !!loginState.user
          && (loginState.state === UserLoginState.FULL_LOGIN_SUCCESS
            || loginState.state === UserLoginState.LOGIN_DIGIRES_ERROR)
        ),
        map(loginState => {
          const user = loginState.user;
          for (const group of this.fncGroups) {
            if (user?.groupsSet?.has(group)) {
              return true;
            }
          }
          console.warn(`Missing required permission ${this.fncGroups}`);
          this.snackBar.open('You do not have permission to view this page', 'Ok', {duration: 3000});
          this.router.navigate(['/']);
          return false;
        })
      );
  }

}
